export default __webpack_public_path__ + "static/media/flower_banner.18f01efd.jpg";